import { SITE } from "@/lib/site";

export const Footer = () => (
  <footer className="bg-[#061a3a] text-slate-300" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <img src={SITE.logo} alt="Sagos Consulting" className="h-12 w-auto object-contain bg-white/95 rounded-lg p-2" />
        <p className="mt-6 max-w-sm text-slate-400 leading-relaxed">
          Boutique financial consulting & advisory. Building, protecting and transferring
          wealth for families and founders since {SITE.founded}.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="overline text-[#8fb4f5] mb-4">Navigate</p>
        <ul className="space-y-3 text-sm">
          {["About", "Services", "Approach", "Team", "Contact"].map((l) => (
            <li key={l}>
              <a href={`#${l.toLowerCase()}`} className="hover:text-white transition-colors">{l}</a>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="overline text-[#8fb4f5] mb-4">Office</p>
        <address className="not-italic text-sm text-slate-400 space-y-2 leading-relaxed">
          <p>{SITE.address.line1}</p>
          <p>{SITE.address.line2}</p>
          <p><a href={SITE.phoneHref} className="hover:text-white transition-colors">{SITE.phone}</a></p>
          <p><a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors">{SITE.email}</a></p>
        </address>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p>© {new Date().getFullYear()} Sagos Consulting. All rights reserved. · {SITE.domain}</p>
        <p className="font-mono tracking-wide">Fiduciary Advisory · SEC-aligned standards</p>
      </div>
    </div>
  </footer>
);
